import { Box, IconButton, Typography, Button } from "@mui/material";
import AppBarContainer from "../../../components/shared/AppBarContainer";
import PageContentContainer from "../../../components/shared/PageContentContainer";
import { ReactComponent as BonusIcon } from "../../../assets/icons/bonus.svg";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useEffect } from "react";
import { useRequest } from "../../../api/utils/useRequest";
import { BalootUserV2APIs } from "../../../api/APIs";
import BottomFullWidthButtonContainer from "../../../components/shared/BottomFullWidthButtonContainer";
import moment from "moment-jalaali";
import CustomRectangularSkeleton from "../../../components/shared/CustomRectangularSkeleton";
import { toToman } from "../../../utils/Utils";

function HistoryReferralPage() {
  const params = useParams();
  const { campaignId } = params;
  const location = useLocation();
  const inviteMessage = location.state.inviteMessage;
  const navigate = useNavigate();
  const {
    loading,
    apiCall: campaignDetails,
    result,
  } = useRequest(BalootUserV2APIs.getCampaignDetails, true);

  useEffect(() => {
    campaignDetails({
      data: { campaignId },
    });
  }, []);

  const handleSharing = async () => {
    if (navigator.share) {
      try {
        await navigator
          .share({
            title: "دعوت به بلوط",
            text: inviteMessage,
          })
          .then(() =>
            console.log("Hooray! Your content was shared to tha world")
          );
      } catch (error) {
        console.log(`Oops! I couldn't share to the world because: ${error}`);
      }
    } else {
      // fallback code
      console.log(
        "Web share is currently not supported on this browser. Please provide a callback"
      );
    }
  };

  return (
    <>
      <AppBarContainer
        rightElement={
          <IconButton onClick={() => navigate(-1)}>
            <ArrowForward sx={{ color: "common.white" }} />
          </IconButton>
        }
        centerElement={
          <Typography variant="h5" color={"common.white"}>
            تاریخچه دعوت از دوستان
          </Typography>
        }
      />

      <PageContentContainer
        sx={{
          overflow: "auto",
          display: "block",
          pb: `calc(env(safe-area-inset-bottom) + 112px )`,
        }}
      >
        {loading ? (
          <>
            <CustomRectangularSkeleton />
            <CustomRectangularSkeleton sx={{ mt: 2 }} height={100} />
            <CustomRectangularSkeleton sx={{ mt: 2 }} height={100} />
          </>
        ) : (
          <>
            <Box
              sx={{
                display: "flex",
                mt: 2,
                px: "16px",
                py: "16px",
                borderRadius: "12px",
                boxShadow: (theme) => theme.shadows[3],
              }}
            >
              <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h5"
                  fontSize={"16px"}
                  color="secondary.main"
                >
                  {result?.achievementDetail.pending}
                </Typography>
                <Typography mt={1} variant="subtitle1" color="grey.9">
                  {"در انتظار"}
                </Typography>
              </Box>

              <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  borderLeft: (theme) => `1px solid ${theme.palette.grey[6]}`,
                }}
              >
                <Typography
                  variant="h5"
                  fontSize={"16px"}
                  color="secondary.main"
                >
                  {result?.achievementDetail.completed}
                </Typography>
                <Typography mt={1} variant="subtitle1" color="grey.9">
                  {"کامل شده"}{" "}
                </Typography>
              </Box>

              <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  borderLeft: (theme) => `1px solid ${theme.palette.grey[6]}`,
                }}
              >
                <Typography
                  variant="h5"
                  fontSize={"16px"}
                  color="secondary.main"
                >
                  {toToman(result?.achievementDetail.bonus)} تومان
                </Typography>

                <Typography mt={1} variant="subtitle1" color="grey.9">
                  {"جایزه دریافت شده"}{" "}
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                mt: 2,
                px: "16px",
                py: "16px",
                borderRadius: "12px",
                boxShadow: (theme) => theme.shadows[3],
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <BonusIcon width={24} height={24} />
                <Typography ml={1} variant="h4" color="grey.2">
                  {result?.campaign.title}
                </Typography>
              </Box>
              <Typography
                mt={1.5}
                variant="body2"
                color="grey.8"
                sx={{ whiteSpace: "pre-line" }}
              >
                {result?.campaign.description}
              </Typography>

              <Typography
                mt={1.5}
                variant="body2"
                color="grey.8"
                sx={{ whiteSpace: "pre-line" }}
              >
                پایان پیشنهاد :&nbsp;
                {moment(result?.campaign.toDate).format("jYYYY/jMM/jDD")}
              </Typography>
            </Box>
          </>
        )}
        <BottomFullWidthButtonContainer>
          <Button
            onClick={handleSharing}
            sx={{
              color: "common.white",
              typography: "h3",
              width: "100%",
              typography: "h3",
              bgcolor: "purple.1",
              "&:hover": {
                bgcolor: "purple.2",
              },
            }}
            variant="contained"
            fullWidth
          >
            دعوت از دوستان
          </Button>
        </BottomFullWidthButtonContainer>
      </PageContentContainer>
    </>
  );
}

export default HistoryReferralPage;
